import WebsiteHeader from "./website-components/WebsiteHeader";
import WebsiteFooter from "./website-components/WebsiteFooter";
import { GooglePlayStore, FaqImg } from "../../assets/img";
import FAQ from "./website-components/FAQ";
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const images = [
  "sliders/jscs64el59zmkdcfwcni.webp",
  "sliders/xndffdmvnflzdl5nyerv.webp",
  "sliders/tzl8gdwu65axmppkq5r8.webp",
  "sliders/mylxars9qtcjgdjvdz3z.webp",
];

const imagesxl = [
  "sliders/rb0ximzlcx2wemh6fusg.webp",
  "sliders/zcwdrmganvodiu8jttb0.webp",
  "sliders/IMG-20250407-WA0015.jpg",
  "sliders/IMG-20250407-WA0016.jpg",
];

const WebsiteIndex = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [seemore, setSeemore] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 10000); // Auto slide every 3 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://dunsregistered.dnb.com/mini.js";
    script.type = "text/javascript";
    script.async = true;

    const container = document.getElementById("dnb-seal-container");

    if (container) {
      container.appendChild(script);
    }

    return () => {
      // Optional cleanup if the component is unmounted
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);

  return (
    <main className="dark:bg-[#F8FAFC] dark:text-black">
      {/* page header */}
      <WebsiteHeader />

      <div id="home">
        {/* hero section desktop and tabs */}
        <div className="bg-[#F8FAFC] relative min-h-[420px] overflow-hidden hidden sm:block">
          <div className="w-full mx-auto">
            <div className="pr-0 lg:pr-20 text-center lg:text-left">
              <div className="w-full mx-auto">
                <div className="rounded-lg shadow-lg">
                  {imagesxl.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Slide ${index}`}
                      className={`absolute w-full min-h-[420px] transition-opacity duration-1000 ease-in-out ${
                        index === currentIndex ? "opacity-100" : "opacity-0"
                      }`}
                    />
                  ))}
                </div>

                <button
                  onClick={prevSlide}
                  className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full hidden"
                >
                  <ChevronLeft size={24} />
                </button>

                <button
                  onClick={nextSlide}
                  className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full hidden"
                >
                  <ChevronRight size={24} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* hero section mobiles*/}
        <div className="bg-[#F8FAFC] relative min-h-[350px] overflow-hidden block sm:hidden">
          <div className="w-full mx-auto">
            <div className="pr-0 lg:pr-20 text-center lg:text-left">
              <div className="w-full mx-auto">
                <div className="rounded-lg shadow-lg">
                  {images.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Slide ${index}`}
                      className={`absolute w-full transition-opacity duration-1000 ease-in-out ${
                        index === currentIndex ? "opacity-100" : "opacity-0"
                      }`}
                    />
                  ))}
                </div>

                <button
                  onClick={prevSlide}
                  className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full hidden"
                >
                  <ChevronLeft size={24} />
                </button>

                <button
                  onClick={nextSlide}
                  className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full hidden"
                >
                  <ChevronRight size={24} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center items-center mt-8">
        <a
          href="https://play.google.com/store/apps/details?id=com.honeconnect.mobile&pli=1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={GooglePlayStore}
            alt="Google Play Store"
            className="h-[50px] w-auto"
          />
        </a>
      </div>

      {/* About hone connect */}
      <div className="px-5 sm:px-10 w-full bg-gray-50 mx-auto py-10 lg:py-16 grid relative">
        <h1 className="relative text-[25px] md:text-[30px] font-bold mb-10 sm:mb-8 text-center">
          Join the
          <span className="text-honeConnectPurple"> Experience</span>
        </h1>

        <div className="text-left font-medium text-sm mx-auto sm:w-8/12 gap-y-3 flex-col flex">
          <p>
            HoneConnect is not just another social networking app — it's a
            revolution in how like-minded people connect, interact, and build
            relationships.
          </p>
          <p>
            Designed for those who value privacy, authenticity, and meaningful
            connections, HoneConnect gives you the power to choose who sees you,
            who interacts with you, and how you engage with your network.
          </p>
          {seemore && (
            <>
              <p>
                With Targeted Connections, you meet people who truly align with
                your interests. Our Smart Exclusions feature ensures you avoid
                unnecessary noise, and our Exclusivity Mode gives you complete
                control over your visibility.
              </p>
              <p>
                Whether you're here to expand your professional network,
                discover new friendships, or engage in private social circles,
                HoneConnect is built for real connections, on your terms.{" "}
              </p>
              <p>
                Join a new era of social networking—where your privacy,
                preferences, and control come first.{" "}
              </p>
              <p>
                Welcome to <span>HoneConnect.</span>
              </p>
            </>
          )}

          <div className="text-right py-3 underline text-honeConnectPurple font-bold">
            <button
              className="border-b border-honeConnectPurple"
              onClick={() => setSeemore(!seemore)}
            >
              {!seemore ? "Read More" : "Read less"}
            </button>
          </div>
        </div>
      </div>

      {/* Hone Connect Benefit Section*/}
      <div
        className="px-5 sm:px-10 w-full mx-auto py-10 lg:py-16 grid bg-white relative scroll-mt-[400px]"
        id="benefit"
      >
        <h1 className="relative text-[25px] md:text-[30px] font-bold mb-10 md:mb-10 text-center">
          Your Social
          <span className="text-honeConnectPurple"> Superpowers</span>
        </h1>

        <div className="grid md:grid-cols-3 justify-between text-center sm:w-11/12 mx-auto gap-10 lg:gap-20">
          <div className="flex flex-row md:flex-col gap-5 md:gap-2">
            <div className="border-[5px] border-honeConnectPurple rounded-[20px] p-4 md:p-4 mx-auto mb-5">
              <img
                src="vl6yydqpj9roeua3u8gm.webp"
                alt=""
                className="max-w-[40px] md:w-[100px] rounded-[5px]"
              />
            </div>
            <div className="flex flex-col text-left md:text-center">
              <p className="text-[16px] md:text-xl font-bold text-[#232630]">
                Targeted Connection
              </p>
              <p className="text-[#6D6D6D] font-medium text-sm mt-1">
                Connect with the right people based on shared interests, values,
                and goals.
              </p>
            </div>
          </div>

          <div className="flex flex-row md:flex-col gap-5 md:gap-2">
            <div className="border-[5px] border-honeConnectPurple rounded-[20px] p-4 md:p-4 mx-auto mb-5">
              <img
                src="cf98t7fs90ry7egsvqw8.webp"
                alt=""
                className="max-w-[40px] md:w-[100px]"
              />
            </div>
            <div className="flex flex-col  text-left md:text-center">
              <p className="text-[16px] md:text-xl font-bold text-[#232630]">
                Smart Exclusions
              </p>
              <p className="text-[#6D6D6D] font-medium text-sm mt-1">
                Stay in control by filtering out unwanted interactions and
                connections.
              </p>
            </div>
          </div>

          <div className="flex flex-row md:flex-col gap-5 md:gap-2">
            <div className="border-[5px] border-honeConnectPurple rounded-[20px] p-4 md:p-4 mx-auto mb-5">
              <img
                src="wruepsqclernvscqjwud.webp"
                alt=""
                className="max-w-[40px] md:w-[100px]"
              />
            </div>
            <div className="flex flex-col  text-left md:text-center">
              <p className="text-[16px] md:text-xl font-bold text-[#232630]">
                Verified Connections
              </p>
              <p className="text-[#6D6D6D] font-medium text-sm mt-1">
                Build trust with authenticated profiles, ensuring real and
                genuine interactions.
              </p>
            </div>
          </div>

          <div className="flex flex-row md:flex-col gap-5 md:gap-2">
            <div className="border-[5px] border-honeConnectPurple rounded-[20px] p-4 md:p-4 mx-auto mb-5">
              <img
                src="cgcgezm8lzwznb6hsqlm.webp"
                alt=""
                className="max-w-[40px] md:w-[100px]"
              />
            </div>
            <div className="flex flex-col  text-left md:text-center">
              <p className="text-[16px] md:text-xl font-bold text-[#232630]">
                Free Connection Requests
              </p>
              <p className="text-[#6D6D6D] font-medium text-sm mt-1">
                Expand your network without limits—no hidden fees or
                restrictions.
              </p>
            </div>
          </div>

          <div className="flex flex-row md:flex-col gap-5 md:gap-2">
            <div className="border-[5px] border-honeConnectPurple rounded-[20px] p-4 md:p-4 mx-auto mb-5">
              <img
                src="dweauxd1lyzqmwg5z5i5.webp"
                alt=""
                className="max-w-[40px] md:w-[100px]"
              />
            </div>
            <div className="flex flex-col  text-left md:text-center">
              <p className="text-[16px] md:text-xl font-bold text-[#232630]">
                Enhanced Social Experience
              </p>
              <p className="text-[#6D6D6D] font-medium text-sm mt-1">
                Enjoy a seamless platform designed for meaningful interactions.
              </p>
            </div>
          </div>

          <div className="flex flex-row md:flex-col gap-5 md:gap-2">
            <div className="border-[5px] border-honeConnectPurple rounded-[20px] p-4 md:p-4 mx-auto mb-5">
              <img
                src="s9q966aln4top49cldh9.webp"
                alt=""
                className="max-w-[40px] md:w-[100px]"
              />
            </div>
            <div className="flex flex-col  text-left md:text-center">
              <p className="text-[16px] md:text-xl font-bold text-[#232630]">
                Stealth Mode User Control
              </p>
              <p className="text-[#6D6D6D] font-medium text-sm">
                Browse and engage discreetly without appearing online or
                notifying others.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Frequently Asked Questions Section*/}
      <div
        className="px-5 sm:px-5 w-full py-10 grid scroll-mt-[400px]"
        id="faq"
      >
        <div className="md:w-11/12 mx-auto grid grid-cols-12 items-center">
          <div className="md:order-2 lg:order-1 col-span-12 lg:col-span-8 lg:pr-40">
            <h1 className="text-center lg:text-left text-[25px] md:text-[30px] font-bold mb-10 md:mb-10 text-[#061737]">
              Frequently
              <span className="text-honeConnectPurple">Asked Questions</span>
            </h1>
            <div className="flex flex-col gap-5">
              <FAQ />
            </div>
          </div>
          <div className="md:order-1 lg:order-2 col-span-12 lg:col-span-4 mx-auto hidden lg:block">
            <img src={FaqImg} alt="" className="h-[400px]" />
          </div>
        </div>
      </div>

      <div
        className="px-4 sm:px-5 w-full py-10 grid scroll-mt-[400px] items-center justify-center"
        id="bdage"
      >
        <a
          href="https://services.ndpc.gov.ng/portal/?page=verify-c&d=ang38667181030&id=64573&sn=032fa18145be16f349709ba84839b10d&t=audit_filing&tp=nwp_audit"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="opyx8dkrbqoytoygg9h4.webp"
            alt="ndpc"
            className="h-[120px]"
          />
        </a>
      </div>

      <WebsiteFooter />
    </main>
  );
};

export default WebsiteIndex;
